<template>
  <div class="text-gray-800 space-x-2 text-sm flex">
    <span class="text-gray-500 hidden sm:block">
      {{ supplierName }}
    </span>
    <NuxtLink
      v-if="props.hasReviewSection"
      to="#sectionReviews"
      class="d-flex align-middle"
    >
      <span
        class="text-gray-500 inline-flex items-center gap-2"
        :class="[
          props.reviewsType === 'event'
            ? 'hover:text-primary transition-colors '
            : '',
        ]"
      >
        <IconStar class="fill-current inline w-[13.5px]" />
        {{ reviewsAverage || $t('product.reviews.newEventLabel') }}
        <template v-if="reviewsAverage && Number(reviewsTotal) > 0">
          <template v-if="props.reviewsType === 'partner'">
            {{ $t('review.partnerRating.label') }}
          </template>
          <template v-else-if="props.reviewsType === 'third-party'">
            {{ $t('review.thirdPartyRating.label') }}
          </template>
          <template v-else>
            {{
              '- ' +
              $t('product.reviews.reviewAmountLabel', Number(reviewsTotal))
            }}
          </template>
        </template>
        <Tooltip
          v-if="
            props.reviewsType === 'partner' ||
            props.reviewsType === 'third-party'
          "
          :tooltip-text="
            props.reviewsType === 'partner'
              ? $t('review.partnerRating.tooltip')
              : $t('review.thirdPartyRating.tooltip')
          "
          length="large"
          position="down-right"
          type="span"
        >
          <InfoCircleFill class="text-gray-300 h-3 w-3 inline" />
        </Tooltip>
      </span>
    </NuxtLink>
    <span v-else class="d-flex align-middle">
      <span
        class="text-gray-500 inline-flex items-center gap-1"
        :class="[
          props.reviewsType === 'event'
            ? 'hover:text-primary transition-colors'
            : '',
        ]"
      >
        <IconStar class="fill-current inline w-[18px]" />
        {{ reviewsAverage || $t('product.reviews.newEventLabel') }}
        <template v-if="reviewsAverage && Number(reviewsTotal) > 0">
          <template v-if="props.reviewsType === 'partner'">
            {{ $t('review.partnerRating.label') }}
          </template>
          <template v-else-if="props.reviewsType === 'third-party'">
            {{ $t('review.thirdPartyRating.label') }}
          </template>
          <template v-else>
            {{
              '- ' +
              $t('product.reviews.reviewAmountLabel', Number(reviewsTotal))
            }}
          </template>
        </template>
        <Tooltip
          v-if="
            props.reviewsType === 'partner' ||
            props.reviewsType === 'third-party'
          "
          :tooltip-text="
            props.reviewsType === 'partner'
              ? $t('review.partnerRating.tooltip')
              : $t('review.thirdPartyRating.tooltip')
          "
          length="medium-large"
          position="down-right"
          type="span"
        >
          <InfoCircleFill class="text-gray-300 h-3 w-3 inline" />
        </Tooltip>
      </span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import IconStar from '~/components/icons/IconStar.vue'
import InfoCircleFill from '~/components/icons/IconInfoCircle.vue'

interface Props {
  supplierName: string
  reviewsAverage: string | number
  reviewsTotal: string | number
  reviewsType: 'event' | 'partner' | 'third-party'
  hasReviewSection?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  hasReviewSection: false,
})

const { t: $t } = useI18n()
</script>
